import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Landing page for the Google Sign-In redirect. The backend hands off the
// access token in the URL fragment (#token=...) rather than a query param,
// so it never gets sent to the server or logged anywhere.
export default function AuthCallback() {
  const { loginWithToken } = useAuth();
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/token=([^&]+)/);
    const token = match ? decodeURIComponent(match[1]) : null;

    if (!token) {
      toast.error("Sign-in failed — no token received");
      nav("/login");
      return;
    }

    loginWithToken(token).then((res) => {
      // Strip the token out of the URL/history regardless of outcome.
      window.history.replaceState(null, "", "/auth/callback");
      if (res.ok) {
        toast.success("Signed in");
        nav("/");
      } else {
        toast.error(res.error || "Sign-in failed");
        nav("/login");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8]">
      <div className="text-sm text-neutral-500">Signing you in…</div>
    </div>
  );
}
